import { useUpdateSuperAdminMutation } from 'generated/graphql';
import {
  appFormUtil,
  gqlCacheUtil
} from 'modules/common';
import { useSavePerson } from 'modules/components/layer12/SavePersonForm/dataService';
import React from 'react';

type IFormState = {
  id: string;
  selection: { id: string; label: string } | null;
  freeText: string;
};

const initialState: IFormState = {
  selection: null,
  id: '',
  freeText: ''
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'id',
        type: 'text'
      },
      selection: {
        label: 'selection',
        type: 'text'
      },
      freeText: {
        label: 'freeText',
        type: 'text'
      }
    }

  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useSaveSuperAdmin() {
  const [
    fnMutate,
    tuple
  ] = useUpdateSuperAdminMutation();

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          input: {
            id,
            isSuperAdmin: true
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
